<template>
    <div class="mainContainer">
        <transition name="overlay">
            <div class="responsive-overlay" v-if="showOverlay"></div>
        </transition>

        <Aside :props-image="appImages" :props-route="route"
            :props-store="{ app: appStore, user: userStore, action: actionStore, menu: menuStore }" v-if="showAside" />
        <Header v-if="showHeader" />
        <main v-if="propIsReady">
            <slot></slot>
            <Scroll :props-store="{ app: appStore }" />
        </main>
        <Footer :props-store="{ app: appStore }" v-if="showFooter" />
    </div>

    <!-- <Alert v-show="showAlertModal" :prop-error="propAlert" /> -->
</template>

<style lang="css" src="../assets/css/mobile.css"></style>

<script lang="ts">
import { defineComponent, defineAsyncComponent } from 'vue';
import { useRoute } from 'vue-router';
import { useAppStore, useUserStore, useActionStore, useMenuStore } from '@coreStores/index';
import { getAppImages } from '@composable/useCommon';
import type { IImages } from '@coreInterfaces/interface';
import Header from '@section/Header.vue';

export default defineComponent({
    name: 'MobileLayout',

    components: {
        // Alert: defineAsyncComponent(() => import('@modal/Alert.vue')),
        Aside: defineAsyncComponent(() => import('@app/base-package').then(module => module.SecAside)),
        Header,
        Footer: defineAsyncComponent(() => import('@app/base-package').then(module => module.SecFooter)),
        Scroll: defineAsyncComponent(() => import('@app/base-package').then(module => module.SecScroll))
    },

    props: {
        propAlert: {
            type: Object,
            required: true
        },
        propIsReady: {
            type: Boolean
        }
    },

    data () {
        return {
            aside: [
                'login',
                'trdLogin',
                'firstLoginPassword',
                '404',
                '500',
                ''
            ] as Array<string>,
            header: [
                'login',
                'trdLogin',
                'firstLoginPassword',
                '404',
                '500',
                ''
            ] as Array<string>,
            footer: [
                'login',
                'trdLogin',
                '404',
                '500',
                ''
            ] as Array<string>
        };
    },

    setup () {
        const route = useRoute();
        const appStore = useAppStore();
        const userStore = useUserStore();
        const actionStore = useActionStore();
        const menuStore = useMenuStore();

        return {
            route,
            appStore,
            userStore,
            actionStore,
            menuStore
        };
    },

    mounted () {
        // console.log('%c MobileLayout - onMounted', 'background: #222; color: #bada55');
    },

    computed: {
        appImages: function (): IImages {
            return getAppImages();
        },

        // showAlertModal: function (): boolean {
        //     return this.actionStore.getModalStatus('alert');
        // },

        showAside: function (): boolean {
            return (!this.aside.includes(this.userStore.getPage())) ? true : false;
        },

        showFooter: function (): boolean {
            return (!this.footer.includes(this.userStore.getPage())) ? true : false;
        },

        showHeader: function (): boolean {
            return (!this.header.includes(this.userStore.getPage())) ? true : false;
        },

        showOverlay: function (): boolean {
            return this.actionStore.getComponentAction('aside') as boolean;
        }
    }
});
</script>
